import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {AppThunk} from "../store.ts";
import {AxiosError} from "axios";
import {PostService} from "../services/post-service.ts";
import {IPostResponseData} from "../models/PostResponse.ts";
import {showCustomErrorToast} from "../../utils/customErrorToast.tsx";

type  InitialStateType = {
   data:IPostResponseData | null
    isLoading:boolean
    reloadState: boolean
};

const initialState: InitialStateType = {
   data:null,
    isLoading:false,
    reloadState:false
}

const slice = createSlice({
    name: "post",
    initialState: initialState,
    reducers: {
        setPostdata: (state: InitialStateType, action: PayloadAction<IPostResponseData | null>) => {
            state.data = action.payload
        },
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload
        },
        changeReloadState: (state, action: PayloadAction<boolean>) => {
            state.reloadState = action.payload;
        },
    },
});
export const postReducer = slice.reducer;
export const postActions = slice.actions;

export const getPostTC = (id: string): AppThunk<Promise<IPostResponseData | void>> =>
    async (dispatch) => {
        dispatch(postActions.setPostdata(null));
        dispatch(postActions.setIsLoading(true));
        try {
            const res = await PostService.fetchPostData(id);
            dispatch(postActions.setPostdata(res.data))
            dispatch(postActions.setIsLoading(false));
            return res.data
        } catch (err) {
            if (err instanceof AxiosError)
                showCustomErrorToast(err.message, 'main', 'bottom-center');
            throw err;
        } finally {
            dispatch(postActions.setIsLoading(false));
        }
    };
